import Axios from 'axios'
// import store from './store'

Axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

if ( localStorage.getItem('ak-adm-token') ) {
  Axios.defaults.headers.common['Authorization'] = `Bearer ${ localStorage.getItem('ak-adm-token') }`
}

// Axios.interceptors.request.use((config) => {
//   if( !config.url.includes( 'payment/make' ) ) {
//     store.commit('TOGGLE_LOADING', true)
//   }
//   return config;
// }, (error) => {
//   store.commit('TOGGLE_LOADING', false)
//   return Promise.reject(error);
// });

// Axios.interceptors.response.use(
//   response => {
//     store.commit('TOGGLE_LOADING', false)
//     return response;
//   },
//   error => {
//     store.commit('TOGGLE_LOADING', false)
//     if (error.response && error.response.status === 401) {
//       router.push('/login')
//     }
//     return Promise.reject(error);
//   }
// );
